import React, { useEffect, useState } from "react";
import { AddButtonIconComponent } from "../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { Modal, Row, Col, Form, Button } from "react-bootstrap";
import PropTypes, { array } from "prop-types";
import { connect } from "react-redux";
import {
  addNewUser,
  getCrusines,
  getFavChains,
  getDietaryPref,
  getAllergies,
  getFavPlaces,
  checkIfEmailExists,
  checkIfPhoneExists,
  getAllCountries,
  getAllStateFromCountry,
  getAllCityFromState,
} from "../../../../store/actions/SuperAdminActions/adminCategoryAndIconsAction";
import isEmpty from "../../../../store/validation/is-Empty";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { Select as MuiSelect } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import { TextField } from "@material-ui/core";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import en from "react-phone-number-input/locale/en.json";
import Alert from "react-s-alert";

function ChooseUserAttributes(props) {
  const [show, setShow] = useState(false);
  const [filterType, setFilterType] = useState(1);
  const [state, setState] = useState({
    DobStarDate: "",
    DobSEndDate: "",
    AnniversaryStarDate: "",
    AnniversaryEndDate: "",
    gender: [],
    Allergies: [],
    Dietary: [],
    Cuisines: [],
    city: '',
    state: '',
    country: '',
    ActiveUsersStartdate: "",
    ActiveUsersenddate: "",
    sendToAll: filterType,
  });

  const [dates, setDates] = useState([]);
  const [allergies, setAllergies] = useState([]);
  const [dietaryPref, setDietaryPref] = useState([]);
  const [popularCuisines, setPopularCrusines] = useState([]);

  const animatedComponents = makeAnimated();
  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];
  const GenderOpts = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Other", label: "Other" },
    { value: "Can't Say", label: "Can't Say" },
  ];

  const onSuccessAllergies = (data) => {
    let allergiesI = [];
    for (let i = 0; i < data.length; i++) {
      allergiesI.push({
        value: data[i]._id,
        label: data[i].title,
        id: data[i]._id,
      });
    }
    setAllergies(allergiesI);
  };

  const onErrorGetAllergies = () => {};

  const onSuccessGetDietaryPref = (data) => {
    let dietaryP = [];
    for (let i = 0; i < data.length; i++) {
      dietaryP.push({
        value: data[i]._id,
        label: data[i].title,
        id: data[i]._id,
      });
    }
    setDietaryPref(dietaryP);
  };

  const onErrorGetDietaryPref = () => {};

  const onSuccessGetCrusines = (data) => {
    let crusines = [];

    for (let i = 0; i < data.length; i++) {
      crusines.push({
        value: data[i]._id,
        label: data[i].title,
        id: data[i]._id,
      });
    }
    setPopularCrusines(crusines);
  };

  useEffect(() => {
    let temp = [];
    for (let i = 0; i <= 30; i++) {
      temp.push(i + 1);
    }
    setDates(temp);
  }, []);

  const onErrorGetCruisnes = () => {};

  useEffect(() => {
    props.getCrusines(onSuccessGetCrusines, onErrorGetCruisnes);
    // props.getFavPlaces(onSuccessGetFavPlaces, onErrorGetFavPlaces);
    // props.getFavChains(onSuccessGetFavChain, onErrorGetFavChain);
    props.getDietaryPref(onSuccessGetDietaryPref, onErrorGetDietaryPref);
    props.getAllergies(onSuccessAllergies, onErrorGetAllergies);
  }, []);

  const [data, setData] = useState({ country: "", state: "", city: "" });

  const onChangeCountry = (e) => {
    props.getAllStateFromCountry(e.target?.value, onSuccessGetAllStates);

    setData({
      [e.target.name]: e.target.value,
      state: "",
      city: "",
    });
    for (let i = 0; i < countries.length; i++) {
      if (e.target.value === countries[i].id) {
        setState({
          ...state,
          country: countries[i].name,
        });
        break;
      }
    }
  };

  const onChangeState = (e) => {
    props.getAllCityFromState(e.target.value, onSuccessGetAllCity);
    setData({
      country: data.country,
      [e.target.name]: e.target.value,
      city: "",
    });
    for (let i = 0; i < states.length; i++) {
      if (e.target.value === states[i].id) {
        setState({
          ...state,
          state: states[i].name,
        });
        break;
      }
    }
  };

  const onChangeCity = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
    for (let i = 0; i < city.length; i++) {
      if (e.target.value === city[i].id) {
        setState({
          ...state,
          city: city[i].name,
        });
        break;
      }
    }
  };
  let [allergiesarr, setallergiesarr] = useState([]);
  const [countries, setAllCountries] = useState([]);
  const [states, setAllStates] = useState([]);
  const [city, setAllCity] = useState([]);
  const [flag,setflag]=useState(true)

  const onSuccessGetAllCountries = (allData) => {
    setAllCountries(allData);
    if (
      props &&
      props.auth &&
      props.auth.user &&
      props.auth.user.VendorUser.country
    ) {
      for (let i = 0; i < allData.length; i++) {
        if (props.auth.user.VendorUser.country === allData[i].iso2) {
          let e = {};
          e.target = {};
          e.target.value = allData[i].id;
          e.target.name = "country";
          onChangeCountry(e, "any");
          // formik1.setFieldValue("country", allData[i].name);
          // formik1.setFieldValue("country_id", allData[i].id);

          break;
        }
      }
    }
  };

  const onSuccessGetAllStates = (data) => {
    setAllStates(data);
  };

  const onSuccessGetAllCity = (data) => {
    setAllCity(data);
  };

  useEffect(() => {
    props.getAllCountries(onSuccessGetAllCountries);
  }, []);
 

  const handlechangegender = (e) => {
    let _localState = [];
    if (e) {
      e.map((data, index) => {
        _localState.push({value:data.value,label:data.label});
      });
      setState({ ...state, gender: _localState });
    } else if (e == null) {
      setState({ ...state, gender: [] });
    }
  };


  const handlechangeAllergies = (e) => {
    let _localState = [];
    if (e) {
      e.map((data, index) => {
        _localState.push({value:data.value,label:data.label}) ;
      });
      setState({ ...state, Allergies: _localState });
    } else if (e == null) {
      setState({ ...state, Allergies: [] });
    }
  };

  const handlechangeDietary = (e) => {
    let _localState = [];
    if (e) {
      e.map((data, index) => {
        _localState.push({value:data.value,label:data.label}) ;
      });
      setState({ ...state, Dietary: _localState });
    } else if (e == null) {
      setState({ ...state, Dietary: [] });
    }
  };
  const handlechangeCuisines = (e) => {
    let _localState = [];
    if (e) {
      e.map((data, index) => {
        _localState.push({value:data.value,label:data.label}) ;
      });
      setState({ ...state, Cuisines: _localState });
    } else if (e == null) {
      setState({ ...state, Cuisines: [] });
    }
  };
  const checkEmprty = (data) => {
    if((filterType === 1) && (data.DobStarDate === "" || data.DobSEndDate === "") 
    &&(data.AnniversaryStarDate === "" || data.AnniversaryEndDate === "") 
    && (data.ActiveUsersStartdate === "" || data.ActiveUsersenddate === "")
    && (data.gender?.length === 0 )
    && (data.Allergies?.length === 0 )
    && (data.Dietary?.length === 0 )
    && (data.Cuisines?.length === 0 ) 
    && (data.city === '')
    && (data.state === '')
    && (data.country === '')
    ) {
      setflag(false);
      Alert.error(`<h4>Please select required fields</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
      return false
    }else{
      setflag(true);
      return true 
    }

  } 
  const [showEdit,setEdit] = useState(false)
  const [btntext,setbtnText]=useState("Choose  Preference")
  const sendAttributes = (data) => {
    console.log(data,"modal data");
   // checkEmprty(data)
    props.datacheck(checkEmprty(data))
    props.AttributesData(data);
    setEdit(true)
    setShow(false);
    setbtnText("Edit User Attributes")
    
  };
 console.log(flag,"filterValue");
  return (
    <div>
       <AddButtonIconComponent
       buttonText ={btntext}
       onClick={() => setShow(true)}
       fontIcon="fa fa-plus"
       colorCss="blue"
     />
      <Modal show={show} size="lg" onHide={() => setShow(false)} centered>
        <Modal.Header closeButton>
          <div className="row w-100">
            <div className="col-6 f20-700 my-4"> Choose User Attributes</div>
          </div>
        </Modal.Header>
        <Modal.Body className="pt-0 pb-0">
          <div className="row checkbox-bank-account justify-content-start mb-4 mt-2">
            <div className="col-4 col-sm-4 col-md-5">
              <label
                className="enRadioWithText small"
                style={{ display: "block" }}
              >
                <div className="f12-500">Send it to all Amealio Users</div>
                <div className="f12-400 opacity5 pl-3">
                  {" "}
                  Email communication will be sent to all the Users in our
                  application
                </div>
                <input
                  id="ActivityType"
                  type="radio"
                  name="ActivityType"
                  value={0}
                  onClick={() => {setFilterType(0); 
                    setState({...state,sendToAll:0})
                  }}
                  defaultChecked={filterType === 0}
                />
                <span className="checkmark"></span>
              </label>
            </div>
            <div className="col-4 col-sm-4 col-md-5">
              <label
                className="enRadioWithText small"
                style={{ display: "block" }}
              >
                <div className="f12-500">Send to Specific Users Group</div>
                <div className="12-400 opacity5 pl-3">
                  Select attributes from the list
                </div>
                <input
                  id="ActivityType"
                  type="radio"
                  name="ActivityType"
                  value={1}
                  onClick={() => {setFilterType(1); 
                    setState({...state,sendToAll:1})
                  }}
                  defaultChecked={filterType}
                />
                <span className="checkmark"></span>
              </label>
            </div>
          </div>
          {filterType === 1 && (
            <Table>
              <TableRow style={{ backgroundColor: "#fff2d5" }}>
                <TableCell>Field Name</TableCell>
                <TableCell>From Value</TableCell>
                <TableCell>To Value</TableCell>
              </TableRow>

              <TableRow>
                <TableCell variant="head">Date of Birth</TableCell>
                <TableCell>
                  <TextField
                    id="start_date"
                    // label="Start Date"
                    variant="outlined"
                    type="date"
                    disablePast
                    //minDate={new Date())}
                    onChange={(e) =>
                      setState({
                        ...state,
                        DobStarDate: e.target.value,
                      })
                    }
                    value={state.DobStarDate}
                    className={`w-100`}
                    name="start_date"
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    id="start_date"
                    // label="Start Date"
                    variant="outlined"
                    type="date"
                    disablePast
                    //minDate={new Date())}
                    onChange={(e) =>
                      setState({
                        ...state,
                        DobSEndDate: e.target.value,
                      })
                    }
                    value={state.DobSEndDate}
                    className={`w-100`}
                    name="start_date"
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell variant="head">Gender</TableCell>
                <TableCell> </TableCell>
                <TableCell>
                  <Select
                    placeholder=" "
                    onChange={(e) => handlechangegender(e)}
                    closeMenuOnSelect={false}
                    components={animatedComponents}
                    isMulti
                    options={GenderOpts}
                    isSearchable
                    defaultValue={state.gender}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell variant="head">Allergies</TableCell>
                <TableCell></TableCell>
                <TableCell>
                  <Select
                    placeholder=" "
                    onChange={(e) =>handlechangeAllergies(e)}
                    closeMenuOnSelect={false}
                    components={animatedComponents}
                    isMulti
                    options={allergies}
                    isSearchable
                    defaultValue={state.Allergies}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell variant="head">Dietary preferences</TableCell>
                <TableCell></TableCell>
                <TableCell>
                  <Select
                    placeholder=" "
                    onChange={(e) =>handlechangeDietary(e)}
                    closeMenuOnSelect={false}
                    components={animatedComponents}
                    isMulti
                    options={dietaryPref}
                    isSearchable
                    defaultValue={state.Dietary}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell variant="head">Cuisines</TableCell>
                <TableCell></TableCell>
                <TableCell>
                  <Select
                    placeholder=" "
                    onChange={(e) =>handlechangeCuisines(e)}
                    closeMenuOnSelect={false}
                    components={animatedComponents}
                    isMulti
                    options={popularCuisines}
                    isSearchable
                    defaultValue={state.Cuisines}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell variant="head">
                  User's Anniversary with Amealio
                </TableCell>
                <TableCell>
                  <TextField
                    id="start_date"
                    // label="Start Date"
                    variant="outlined"
                    type="date"
                    disablePast
                    //minDate={new Date())}
                    onChange={(e) =>
                      setState({
                        ...state,
                        AnniversaryStarDate: e.target.value,
                      })
                    }
                    value={state.AnniversaryStarDate}
                    className={`w-100`}
                    name="start_date"
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    id="start_date"
                    // label="Start Date"
                    variant="outlined"
                    type="date"
                    disablePast
                    //minDate={new Date())}
                    onChange={(e) =>
                      setState({
                        ...state,
                        AnniversaryEndDate: e.target.value,
                      })
                    }
                    value={state.AnniversaryEndDate}
                    className={`w-100`}
                    name="start_date"
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell variant="head">Country</TableCell>
                <TableCell></TableCell>
                <TableCell>
                  <MuiSelect
                    style={{ width: "100%" }}
                    value={data.country}
                    //value="101"
                    onChange={onChangeCountry}
                    label="country"
                    inputProps={{
                      name: "country",
                      id: "outlined-country",
                    }}
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    {countries.map((country, index) => (
                      <option key={index} value={country.id}>
                        {country.name}
                      </option>
                    ))}
                  </MuiSelect>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell variant="head">State</TableCell>
                <TableCell></TableCell>
                <TableCell>
                  <MuiSelect
                    style={{ width: "100%" }}
                    value={data.state}
                    onChange={onChangeState}
                    label="state"
                    inputProps={{
                      name: "state",
                      id: "outlined-state",
                    }}
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    {states.map((state, index) => (
                      <option key={index} value={state.id}>
                        {state.name}
                      </option>
                    ))}
                  </MuiSelect>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell variant="head">City</TableCell>
                <TableCell></TableCell>
                <TableCell>
                  <MuiSelect
                    style={{ width: "100%" }}
                    value={data.city}
                    onChange={onChangeCity}
                    label="state"
                    inputProps={{
                      name: "city",
                      id: "outlined-state",
                    }}
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    {city.map((city, index) => (
                      <option key={index} value={city.id}>
                        {city.name}
                      </option>
                    ))}
                  </MuiSelect>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell variant="head">Active User's Paramaters</TableCell>
                <TableCell>
                  <TextField
                    id="start_date"
                    // label="Start Date"
                    variant="outlined"
                    type="date"
                    disablePast
                    //minDate={new Date())}
                    onChange={(e) =>
                      setState({
                        ...state,
                        ActiveUsersStartdate: e.target.value,
                      })
                    }
                    value={state.ActiveUsersStartdate}
                    className={`w-100`}
                    name="start_date"
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    id="start_date"
                    // label="Start Date"
                    variant="outlined"
                    type="date"
                    disablePast
                    //minDate={new Date())}
                    onChange={(e) =>
                      setState({
                        ...state,
                        ActiveUsersenddate: e.target.value,
                      })
                    }
                    value={state.ActiveUsersenddate}
                    className={`w-100`}
                    name="start_date"
                  />
                </TableCell>
              </TableRow>
            </Table>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-dark" onClick={() => setShow(false)}>
            Cancel
          </Button>
             <button
            className="btn btn-danger"
            onClick={() => sendAttributes(state)}
          >
            Save
          </button>
         
        </Modal.Footer>
      </Modal>
    </div>
  );
}

ChooseUserAttributes.propTypes = {
  auth: PropTypes.object.isRequired,
  getCrusines: PropTypes.func.isRequired,
  getFavPlaces: PropTypes.func.isRequired,
  getFavChains: PropTypes.func.isRequired,
  getDietaryPref: PropTypes.func.isRequired,
  getAllergies: PropTypes.func.isRequired,
  getAllStateFromCountry: PropTypes.func.isRequired,
  getAllCityFromState: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

// export default ChooseUserAttributes; 
export default connect(mapStateToProps, {
  getCrusines,
  getFavPlaces,
  getFavChains,
  getDietaryPref,
  getAllergies,
  getAllCountries,
  getAllStateFromCountry,
  getAllCityFromState,
})(ChooseUserAttributes);
